import fetch from './fetch'

export default function download(url, params = {}, fileName = 'laporan') {
  return new Promise((resolve, reject) => {
    fetch({
      url,
      params,
      method: 'GET',
      responseType: 'blob' // important
    })
      .then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', `${fileName}.pdf`)
        document.body.appendChild(link)
        link.click()
        return resolve()
      })
      .catch(err => reject(err))
  })
}
